import { GridColDef } from "@mui/x-data-grid-premium";
import { Grid } from "@mui/material";
import AdverseEffectFormRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import AdverseEffectForm from "../create";
import { useTranslate } from "src/locales";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//MUZUN;454081;07042025
const columns: GridColDef[] = [
    { field: "date", headerName: "Tarih", flex: 1 },
    { field: "field1", headerName: "Alan 1", flex: 1 },
    { field: "field2", headerName: "Alan 2", flex: 1 },
    { field: "field3", headerName: "Alan 3", flex: 1 },
    { field: "field4", headerName: "Alan 4", flex: 1 },
    { field: "field5", headerName: "Alan 5", flex: 1 },
    {
        field: "update",
        headerName: "Düzenle",
        flex: 1,
        renderCell: (params) => (
            <ByzGrdEditButton
                onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
            />
        ),
    },
    {
        field: "delete",
        headerName: "Sil",
        flex: 1,
        renderCell: (params) => (
            <ByzGrdDeleteButton
                onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
            />
        ),
    },
];

function AdverseEffectFormList() {
    const { t } = useTranslate();
    
    return (
        <>
            <BaseMedCardList
                title={t("adverse-effect-form.title")}
                columns={columns}
                rows={AdverseEffectFormRows}
                CreateComponent={AdverseEffectForm}
                pageSize={10}
            />

            <ByzMuiTypography
                sx={{
                    fontSize: 13,
                    fontWeight: 400,
                    whiteSpace: "nowrap",
                    wordWrap: "break-word",
                    margin: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Grid container spacing={1} style={{ width: "100%" }}>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            padding: "10px",
                            color: "black",
                        }}
                    >
                    </Grid>
                </Grid>
            </ByzMuiTypography>
        </>
    );
}

export default AdverseEffectFormList;
